// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"538":"638e7bf2","671":"a10dc97c"}[chunkId] + ".chunk.css";
};